import { render, staticRenderFns } from "./SchoolManage.vue?vue&type=template&id=dbb710c2&scoped=true"
import script from "./SchoolManage.vue?vue&type=script&lang=js"
export * from "./SchoolManage.vue?vue&type=script&lang=js"
import style0 from "./SchoolManage.vue?vue&type=style&index=0&id=dbb710c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb710c2",
  null
  
)

export default component.exports